__turbopack_context__.v({
  "desktopMenuWrapper": "SimpleHeader-module-scss-module__tz5CgW__desktopMenuWrapper",
  "desktopMenuWrapperFixed": "SimpleHeader-module-scss-module__tz5CgW__desktopMenuWrapperFixed",
  "mainContainer": "SimpleHeader-module-scss-module__tz5CgW__mainContainer",
  "menuItemContainer": "SimpleHeader-module-scss-module__tz5CgW__menuItemContainer",
  "navbarPlaceholder": "SimpleHeader-module-scss-module__tz5CgW__navbarPlaceholder",
  "simpleMenuContainer": "SimpleHeader-module-scss-module__tz5CgW__simpleMenuContainer",
});
